export default __webpack_public_path__ + "static/media/icon_drag.39344bce.svg";